import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// ----------CONSTRUCCIONES
export const getConstrucciones = async () => {
  const respuesta = await PrivateInterceptor(`Global/Construcciones`, "GET");
  return respuesta;
};

export const getConstruccionesPorID = async (IdConstruccion) => {
  const respuesta = await PrivateInterceptor(`Global/Construcciones/PorID`, "POST", {IdConstruccion});
  return respuesta;
};

export const GuardarConstruccion = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Construcciones/GuardarConstruccion", "POST", {Datos});
  return respuesta;
};

export const EditarConstruccion = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Construcciones/EditarConstruccion", "POST", {Datos});
  return respuesta;
};

export const cambiarEstadoConstrucciones = (data) => {
  const respuesta = PrivateInterceptor("Global/Construcciones/EliminarConstrucciones", "POST", data);
  return respuesta;
};

// ----------SUBCONSTRUCCIONES
export const getSubConstrucciones = async () => {
  const respuesta = await PrivateInterceptor(`Global/Construcciones/SubConstrucciones`, "GET");
  return respuesta;
};


export const GuardarSubConstruccion = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Construcciones/GuardarSubConstruccion", "POST", {Datos});
  return respuesta;
};

export const EliminarSubConstrucciones = (data) => {
  const respuesta = PrivateInterceptor("Global/Construcciones/EliminarSubConstrucciones", "POST", data);
  return respuesta;
};

export const getConstruccionesConcatenadas = () => {
  const respuesta = PrivateInterceptor("Global/Construcciones/getConstruccionesConcatenadas", "GET");
  return respuesta;
};